module Meevo.Plugins.AppointmentBook {
    
    class ServiceInformationController {
	    private modal;
	    private service;
		static $inject = ['appointmentBookModalService', "meevo.components.common.DataService", "meevo.AppSettings", "serviceId"];
        constructor(modal: any,
	        dataService: Meevo.Components.BaseClasses.IDataService,
	        appSettings: Meevo.Components.Common.IAppSettings,
	        serviceId: any) {
			this.modal = modal;

			dataService.getSectionById(appSettings.API_ENDPOINTS.service, serviceId, "")
		        .then((response) => {
			        this.service = response;
		        });
        }
    }

    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.ServiceInformationController", ServiceInformationController);
}